(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cn-main-product"]) return;
  try {
    document.addEventListener('change',event=>{const select=event.target.closest('[data-variant-select]');if(!select)return;const option=select.selectedOptions[0];const root=select.closest('.cn-product__info');root.querySelector('[data-product-price]').textContent=option.dataset.price;const button=root.querySelector('[data-add-button]');const available=option.dataset.available==='true';button.disabled=!available;button.textContent=available?'Add to bag':'Sold out';history.replaceState({},'',location.pathname+'?variant='+option.value)});
  } catch(e) { console.error(e); }
})();
})();
